export const scrollToId = (id: string) => {
  document.getElementById(id)?.scrollIntoView()
}

export const scrollToTab = (id: string) => {
  document.getElementById(id)?.scrollIntoView()
}
